<template>
  <b-modal
    ref="modal"
    size="lg"
    centered
    lazy
    no-close-on-esc
    no-close-on-backdrop
    :hide-header="true"
    class="address-modal"
  >
    <LoadingSpinner v-if="loading" />
    <h6 class="mb-4">Shipping Address</h6>
    <b-form-row>
      <b-col>
        <b-form-group>
          <b-form-textarea
            v-model="long_address"
            placeholder="Name
Company (Optional)
Address Line 1
Address Line 2 (Optional)
City State Postal Code"
            rows="5"
            @change="onChange"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group>
          <b-form-input
            type="text"
            :class="[{'is-invalid': !(addr.company || addr.first_name || addr.last_name)}]"
            placeholder="First Name"
            v-model="addr.first_name"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <b-form-input
            type="text"
            :class="[{'is-invalid': !(addr.company || addr.first_name || addr.last_name)}]"
            placeholder="Last Name"
            v-model="addr.last_name"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group>
          <b-form-input
            type="text"
            :class="[{'is-invalid': !(addr.company || addr.first_name || addr.last_name)}]"
            placeholder="Company"
            v-model="addr.company"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group>
          <b-form-input
            type="text"
            :class="[{'is-invalid': !addr.address}]"
            placeholder="Address Line 1"
            v-model="addr.address"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <b-form-input
            type="text"
            placeholder="Address Line 2 (FL, Apt, Suite, etc.)"
            v-model="addr.address2"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group>
          <zip-code-input
            :class="['form-control', {'is-invalid': !addr.postal_code}]"
            placeholder="Postal Code"
            v-model="addr.postal_code"
            :formatZip="addr.country === 'US'"
            @change="getCityState(addr.postal_code)"
          ></zip-code-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <b-form-input
            type="text"
            :class="[{'is-invalid': !addr.city}]"
            placeholder="City"
            v-model="addr.city"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group>
          <b-form-input
            type="text"
            :class="[{'is-invalid': !addr.province}]"
            placeholder="State/Province"
            v-model="addr.province"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <b-form-input
            type="text"
            :disabled="true"
            :class="[{'is-invalid': !addr.country}]"
            placeholder="Country"
            v-model="addr.country"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>

    <div slot="modal-footer" class="w-100 text-right">
      <div class="float-left">
        <b-btn size="sm" variant="primary" @click="onClearItems">Clear All</b-btn>
      </div>
      <div class="float-right">
        <b-btn size="sm" variant="primary" @click="onHideModal(true)" :disabled="checkFields">Save and Close</b-btn>
        <b-btn
          size="sm"
          style="background-color: #858888; border-color: #858888"
          @click="onHideModal(false)"
        >Close</b-btn>
      </div>
    </div>
  </b-modal>
</template>

<style lang="scss" scoped>
  input, textarea, button {
    font-size: .75rem;
  }
  textarea {
    resize: none;
  }
</style>
<script>
import human from 'parse-full-name';
import parser from 'parse-address';

import LoadingSpinner from "../LoadingSpinner";

export default {
  components: {
    LoadingSpinner,
  },
  props: ["address"],
  data() {
    return {
      loading: false,
      long_address: '',
      addr: {
        company: '',
        first_name: '',
        last_name: '',
        state: '',
        province: '',
        city: '',
        address: '',
        address2: '',
        postal_code: '',
        country: 'US',
      },
      tmpAddress: null,
    };
  },
  computed: {
    checkFields() {
      return (
        !(this.addr.first_name || this.addr.last_name || this.addr.company) || !this.addr.address ||
        !this.addr.postal_code || !this.addr.province || !this.addr.city || !this.addr.country
      )
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
      this.long_address = ''
      this.addr = this.tmpAddress = _.cloneDeep(this.address);
    },
    onChange(val) {
      if (val) {
        this.parseAddress(val);
      } else {
        this.onClearItems();
      }
    },
    onClearItems() {
      this.addr = {
        company: '',
        first_name: '',
        last_name: '',
        state: '',
        province: '',
        city: '',
        address: '',
        address2: '',
        postal_code: '',
        country: 'US',
      }
      this.long_address = ''
    },
    onHideModal(save) {
      if (save) {
        this.$emit('save', this.addr);
      } else {
        this.addr = this.tmpAddress;
      }
      this.$refs.modal.hide();
    },
    async parseAddress(long_address) {
      let address = long_address.split(/\r?\n/).map(a => a.trim()).filter(a => a.length > 0);

      if (address.length === 1) {
        address = long_address.split(/,/).map(a => a.trim()).filter(a => a.length > 0);
        this.long_address = address.join('\r\n');
      }

      console.log('parsing address', address);

      if (address.length > 2) {
        this.loading = true;
        // check if country is on the last element then remove
        if (['us', 'usa', 'america', 'united states', 'united states of america'].includes(address[address.length - 1].trim().toLowerCase())) {
          address.pop();
        }

        // parse name (Expecting that the first row is name)
        let first = address.shift();
        let parsedName = human.parseFullName(first);

        // if address doesn't have number, move it to company
        let second = address[0];
        let company = '';

        const re = /\d/;
        if (!re.test(second)) {
          company = second;
          address.shift();
        }

        // address parser
        const parsedAddress = parser.parseLocation(address.join(' '));
        const postal_code = parsedAddress.plus4 ? `${parsedAddress.zip}-${parsedAddress.plus4}` : parsedAddress.zip

        if (!postal_code) {
          this.loading = false;
          this.$parent.$emit('alert', {
            message: 'Postal code is required.',
            type: 'danger'
          });
        } else {
          // get city state from ziptastic api
          const city_state = await this.getCityState(postal_code);

          let data = {
            company: company,
            first_name: parsedName.first,
            last_name: parsedName.last,
            state: city_state.state,  // new shipment uses province
            province: city_state.province,
            city: city_state.city,
            address: address[0],
            address2: address.length > 2 ? address[1] : '',
            postal_code: postal_code,
            country: 'US',
          }

          this.addr = Object.assign({}, this.addr, data)
        }
      }
    },
    async getCityState(zip) {
      this.loading = true;

      let url = "https://zip.getziptastic.com/v2/US/" + zip;
      var axiosCrossDomain = axios;
      delete axiosCrossDomain.defaults.headers.common["X-CSRF-TOKEN"];
      delete axiosCrossDomain.defaults.headers.common["X-Requested-With"];

      try {
        const { data } = await axiosCrossDomain(url, { method: "GET" });
        const pattern = /^(APO|FPO|DPO)\s(AE|AA|AP)$/
        let {state_short, city, country} = data;

        if(pattern.test(city.toUpperCase())){
          const [c,s] = city.split(" ");
          state_short = s;
          city = c;
        }

        this.addr.city = city;
        this.addr.province = state_short;
        this.addr.state = state_short;
        // this.addr.country = country;

        return {
          city: city,
          province: state_short,
          state: state_short,
        }
      } catch(error) {
        console.log('City State Error: ', error);
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Modals/DropInAddress.vue